<template>
    <modal :show.sync="show" modalClasses="cases-modal" headerClasses="pb-0" :hide-footer="true">
        <div style="max-width:1200px">
            <PreviewModal ref="preview_modal"></PreviewModal>
            <h3 slot="header" class="mb-0 font-weight-500">Documents</h3>
            <b-row>
                <b-col cols="12" md="6">
                    <b-form-group label="Search" class="mb-0">
                        <base-input
                        v-model="searchQuery"
                        prepend-icon="fas fa-search"
                        placeholder="Search"
                        ></base-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <el-collapse accordion v-model="activeNames">
                        <el-collapse-item name="1" class="my-3">
                            <div slot="title" class="collapse-header">
                                <h3 class="mb-0">Customer Documents({{ customerDocuments.length }})</h3>
                            </div>
                            <div class="border rounded py-2" style="background: #F6F9FD;" v-if="customerDocuments.length > 0">
                                <b-row class="align-items-center mx-0" 
                                    :class="index !== customerDocuments.length - 1 ? 'border-bottom pb-2 mb-2' : ''" 
                                    v-for="(document, index) in customerDocuments" 
                                    :key="index"
                                >
                                    <b-col cols="1" md="1">
                                        <b-form-checkbox
                                        v-model="selected_documents"
                                        :value="document.attachment_id"
                                        ></b-form-checkbox>
                                    </b-col>
                                    <b-col cols="1">
                                        <a href="javascript:void(0)" @click="downloadDocument(document)">
                                            <i class="fa fa-download text-primary"></i>
                                        </a>
                                    </b-col>
                                    <b-col cols="7">
                                        <div class="d-flex align-items-end">
                                            <a 
                                                href="javascript:void(0)" 
                                                @click="$refs.preview_modal.preview(
                                                    document.url, 
                                                    document.display_filename
                                                )" 
                                                class="text-truncate mr-2"
                                            >{{ document.display_filename }}</a>
                                        </div>
                                        <small>{{ document.remark }}</small>
                                    </b-col>
                                    <b-col cols="3" class="text-right" v-if="document.submitted_at">
                                        {{ document.submitted_at | dateTimeFormatString }}
                                    </b-col>
                                </b-row>
                            </div>
                            <div v-else>
                                No documents found.
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </b-col>
                <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button variant="primary" type="submit" class="w-100" @click="submitDocuments" v-if="selected_documents.length > 0" :disabled="is_loading_submit">Submit</b-button>
                </b-col>
            </b-row>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { DatePicker, Collapse, CollapseItem } from 'element-ui'
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    helperFunctionMixin
} from '@/assets/js/httpImports.js'
import { integer } from 'vee-validate/dist/rules'
import PreviewModal  from '@/components/Modal/PreviewModal'
import { useProductStore } from '@/stores/productStore'
import { mapState, mapActions } from 'pinia'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'

export default {
    props:{
        show_documents: Boolean,
        bank: Object,
        product: Object,
        customer_id: integer
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        PreviewModal,
        Modal,
        [DatePicker.name]: DatePicker,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
    },
    computed: {
        show: {
            get() {
                return this.show_documents;
            },
            set(newVal) {
                this.$emit('update:show_documents', newVal);
            },
        },
        customerDocuments(){
            if(this.searchQuery === ''){
                return this.customer_documents
            }
            return this.customer_documents.filter((document) => {
                let search = this.searchQuery.toLowerCase()
                if(
                    document.original_filename.toLowerCase().includes(search) || 
                    (document.attachment_category && document.attachment_category.name.toLowerCase().includes(search))
                ){
                    return true
                }
                return false
            })
        }
    },
    data() {
        return {
            searchQuery: '',
            date_picked: '',
            doc_check: '',
            customer_documents:[],
            bank_documents:[],
            activeNames:['1'],
            selected_documents: [],
            bank_id: null,
            is_loading_submit: false
        }
    },
    methods:{
        ...mapActions(useProductStore, ['updatePropertyProductBankStatus','sendEmailToBanker']),
        getCustomerAttachments(){
            axios.get(services.customer + 'customer/' + this.customer_id +'/attachments.all', {headers: getHeader()})
                .then(res => {
                    this.customer_documents = res.data.data
                    for(let x = 0; x < this.customer_documents.length; x++){ 
                        const document = this.customer_documents[x]
                        document.display_filename = document.attachment_category ? 
                            document.attachment_category.name + ' - ' + document.original_filename : 
                            document.original_filename
                    }
                    this.setSelectedBankDocuments()
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
        getBankAttachments(bank_id){
            this.selected_documents = []
            this.bank_id = bank_id
            axios.get(services.attachment + 'bank_attachments/' + this.bank_id, {headers: getHeader()})
                .then(res => {
                    this.bank_documents = res.data.data
                    this.setSelectedBankDocuments()
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
        submitDocuments(){
            let formData = {
                bank_id: this.bank_id,
                attachment_ids: this.selected_documents
            }
            this.is_loading_submit = true
            axios.post(services.attachment + 'bank_attachments.bulk', formData, {headers: getHeader()})
                .then(async (res) => {
                    try{
                        await this.updatePropertyProductBankStatus(this.bank, 'Processing', this.bank.prod_bnk_submission_date ? false : true)
                    }catch(e){
                        this.is_loading_submit = false
                        this.errorFunction(e)
                        return
                    }
                    this.notifySuccess('<b>Bank</b> - Successfully Submitted.')
                    this.bank_documents = res.data.data

										//SEND TO BANKER
										this.sendEmailToBanker(this.bank,this.product,this.bank_documents);
                    this.setSelectedBankDocuments()
                    this.$emit('update:show_documents', false);
                    caseEventBus.$emit('refresh-cases')
                    this.is_loading_submit = false
                })
                .catch(e => {
                    this.is_loading_submit = false
                    this.errorFunction(e)
                })
        },
        setSelectedBankDocuments(){
            // reset submitted at
            for(let x = 0; x < this.customer_documents.length; x++){ 
                delete this.customer_documents[x].submitted_at
            }
            for(let i = 0; i<this.bank_documents.length; i++){
                const attachment_id = this.bank_documents[i].attachment.attachment_id
                if(!this.selected_documents.includes(attachment_id)){
                    this.selected_documents.push(attachment_id)
                }
                for(let x = 0; x < this.customer_documents.length; x++){ 
                    if(this.customer_documents[x].attachment_id == attachment_id){
                        this.customer_documents[x].submitted_at = this.bank_documents[i].created_at
                    }
                }
            }
        },
        downloadDocument(document){
            axios.get(services.attachment + 'attachments/' + document.attachment_id + '/download',{
                    headers: getHeader(),
                    responseType: 'blob'
                })
                .then(response => {
                    this.createDownloadFileLink(response.data, document.display_filename)
                })
                .catch(e => {
                    this.errorFunction(e)
                });
        }
    }
}
</script>